var path = '/content/externalContent/externalContent.tpl.html';
var html = "<content-iframe iframe-src=\"viewModel.externalContentUrl\"\n                popout-url=\"viewModel.externalContentPopoutUrl\" />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;